import React from 'react';
import {
    ListGroup,
    ListGroupItem
} from 'react-bootstrap';

type ListProps = React.ComponentPropsWithoutRef<typeof ListGroup>;

const List: React.FC<ListProps> & {
  Item: typeof ListGroupItem;
} = (props) => {
  return <ListGroup {...props} />;
};

List.Item = ListGroupItem;

export default List;
